import { EDITOR_KEY_GROUPS } from './editorKeys';

/** The editor's Keys side tab (1.7.4): every editor shortcut, grouped by area (editorKeys.ts). */
export function KeysTab() {
  return (
    <div className="keys-tab" data-testid="editor-keys">
      <div className="shortcut-grid editor-shortcut-grid" data-testid="editor-shortcuts">
        {EDITOR_KEY_GROUPS.map((g) => (
          <div key={g.area} style={{ display: 'contents' }}>
            <p className="section-label keys-area" data-testid="keys-area">{g.area}</p>
            {g.rows.map((r) => (
              <div key={r.label} style={{ display: 'contents' }}>
                <span>{r.label}</span>
                <span className="keys">{r.keys.map((k) => (k.includes(' ') && !/^[⌘⇧⌥⌃] /.test(k) ? <span key={k} className="faint">{k}</span> : <kbd key={k}>{k}</kbd>))}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
